export const jobs_EN = [
  {
    title: "CMPC",
    time: "2022 - Present",
    description: "Reactjs developer",
    details: "Part of the innovation team, in charge of digitizing processes and creating a world class and use platform where customer contact with the company can be modernized.",
  },
  {
    title: "Mobdev",
    time: "2022",
    description: "ReactJs developer",
    details: "As part of this external business, I provided services for Scotiabank de Chile, in a cell where I worked on solving problems with the tools already implemented, or making changes that did not exceed 2 weeks.",
  },
  {
    title: "Devaid",
    time: "2020 - 2022",
    description: "ReactJs developer",
    details: "I have worked as a ReactJs developer, where I have done maintenance on an already created 'ticketera' application, in addition, I have created a route management application from scratch.",
  },
  {
    title: "PiikApp",
    time: "2020",
    description: "ReactJs & RoR developer",
    details: "I worked as a software developer in ReactJs and Ruby on Rails, where I did maintenance on the business API and website, as well as creating a general management platform for the business.",
  },
  {
    title: "SCD",
    time: "2019 - 2020",
    description: "Angular 7+ & SpringBoot developer",
    details: "First job as a software developer, where I participated in the creation of internal tools for the company.",
  },
  {
    title: "Everis Temuco",
    time: "2018 - 2019",
    description: "ETL Developer",
    details: "First formal job, where I worked as a developer in Business Intelligence, creating ETL's in PowerCenter for Banco Santander de Murcia.",
  },
];
